<template>
    <eg-modal :height="height" :width="width" :show="show" @close="$emit('close', false)">
        <p class="center" slot="header">Dados do fornecedor</p>
        <div class="my-proposal-modal-body" slot="body">
            <p>Nome: {{ supplier.responsible }}</p>
            <p>Email: {{ supplier.email }}</p>
            <p>Telefone: {{ supplier.phone }}</p>
        </div>
    </eg-modal>
</template>

<script>
export default {
    name: 'SupplierDetails',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean, supplier: Object }
};
</script>

<style></style>
